import { FormGroup, AbstractControl } from "@angular/forms";

export function ComparePhone(
  controlName: string,
  matchingControlName: string
) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.phoneMatch) {
      return;
    }

    if (control.value === matchingControl.value) {
      matchingControl.setErrors({ phoneMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}

export function CheckCorrectPhoneNumber(controlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const value = control?.value;

    if (!value) return;

    const con = containsDigitRepeating5OrMoreTimes(value);
      if (!con) {
      control.setErrors(null);
    } else {
      control.setErrors({ phonePattern: true });
    }
  };
}
function containsDigitRepeating5OrMoreTimes(str) {
  // This regex finds any digit that repeats 5 or more times in the string
  const regex = /(\d)(?=(?:\D*\1){4})/;

  // Check if the string matches the regex
  return regex.test(str);
}
